module.exports={"wireguard adapter settings":"Ustawienia adaptera dla wireguard",option1:"opcja 1",option2:"Opcja 2"};